import {
  getPriceRangeFromQueryParam,
  getSelectedPriceRangeFromRefineParam
} from "../helpers/priceRangeUrl";
import {
  getMinMaxFromApiResponse,
  isPriceRangeSelected,
  isFacetPriceRange
} from "../selectors";

const CURRENT_PRICE_FACET_ID = "currentprice";

const replaceCurrentPriceSelections = (
  selectedFacets,
  nextCurrentPriceSelections
) =>
  selectedFacets
    .filter(facet => facet.facetId !== CURRENT_PRICE_FACET_ID)
    .concat(nextCurrentPriceSelections);

const createCurrentPriceSelections = (state, getPriceRange, isSelected) =>
  getPriceRange(state).map(facet => ({
    facetId: facet.id,
    isSelected,
    valueId: facet.facetValues[0].id
  }));

export const commandUpdateRangeFacet = (
  state,
  { value },
  { calculateHasSelectedValuesState, getPriceRange }
) => {
  state.range.currentprice.selected.temp = value;
  state.range.currentprice.hasSelectedValues = calculateHasSelectedValuesState(
    value,
    state.range.currentprice
  );
  state.selectedFacets = replaceCurrentPriceSelections(
    state.selectedFacets,
    createCurrentPriceSelections(state, getPriceRange, true)
  );
};

export const commandClearRangeFacet = (state, { getPriceRange }) => {
  state.range.currentprice.selected.temp = {
    leftIndicator: state.range.currentprice.min,
    rightIndicator: state.range.currentprice.max
  };
  state.range.currentprice.hasSelectedValues = false;
  state.selectedFacets = replaceCurrentPriceSelections(
    state.selectedFacets,
    createCurrentPriceSelections(state, getPriceRange, false)
  );
};

export const commandSetRangeValues = (
  state,
  { values },
  { calculateHasSelectedValuesState }
) => {
  const previousSelectedFacets = state.selectedFacets;
  state.oldSelectedFacets = previousSelectedFacets;
  state.selectedFacets = previousSelectedFacets.filter(
    facet => facet.facetId !== CURRENT_PRICE_FACET_ID
  );
  state.range.currentprice.selected.previous =
    state.range.currentprice.selected.current;
  state.range.currentprice.selected.current = values;
  state.range.currentprice.selected.temp = null;
  state.range.currentprice.hasSelectedValues = calculateHasSelectedValuesState(
    values,
    state.range.currentprice
  );
};

export const getCurrentSelectedPriceRange = (
  initialState,
  state,
  hasSelectedValues,
  minMaxBounds,
  refine,
  isNewPage
) => {
  let currentSelectedPriceRange = {};
  if (
    state.range.currentprice.selected.current ===
      initialState.range.currentprice.selected.current ||
    isNewPage
  ) {
    if (hasSelectedValues) {
      const [
        leftIndicator,
        rightIndicator
      ] = getSelectedPriceRangeFromRefineParam(refine);

      currentSelectedPriceRange = {
        leftIndicator,
        rightIndicator
      };
    } else {
      currentSelectedPriceRange = {
        leftIndicator: minMaxBounds.min,
        rightIndicator: minMaxBounds.max
      };
    }
  } else {
    currentSelectedPriceRange = state.range.currentprice.selected.current;
  }

  return currentSelectedPriceRange;
};

const getBound = ({ hasSelected, boundType, queryMinMax, apiMinMax }) => {
  const { [boundType]: query } = queryMinMax;
  const { [boundType]: api } = apiMinMax;

  return hasSelected && Number.isInteger(query) ? query : api;
};

const getBounds = ({
  currentpricerange,
  hasSelectedValues,
  facets,
  refine
}) => {
  const otherFacetsHasSelectedValue = facets.some(
    facet => !isFacetPriceRange(facet) && facet.hasSelectedValues
  );

  const hasSelected = otherFacetsHasSelectedValue || hasSelectedValues;
  let queryMinMax = getPriceRangeFromQueryParam(currentpricerange);

  if (Object.keys(queryMinMax).length === 0 && hasSelectedValues) {
    const [min, max] = getSelectedPriceRangeFromRefineParam(refine);
    if (Number.isFinite(min) && Number.isFinite(max)) {
      queryMinMax = { min, max };
    }
  }

  const apiMinMax = getMinMaxFromApiResponse({
    facets
  });

  return ["min", "max"].reduce(
    (bounds, boundType) => ({
      ...bounds,
      [boundType]: getBound({ hasSelected, boundType, queryMinMax, apiMinMax })
    }),
    {}
  );
};

export const getNewRangeState = (
  initialState,
  state,
  facets,
  query,
  isNewPage
) => {
  const { currentpricerange, refine } = query;
  const selectedFromRefine = getSelectedPriceRangeFromRefineParam(refine);
  const hasSelectedValues =
    isPriceRangeSelected({ facets }) ||
    (selectedFromRefine.length === 2 &&
      selectedFromRefine.every(Number.isFinite));

  const minMaxBounds = getBounds({
    currentpricerange,
    hasSelectedValues,
    facets,
    refine
  });

  return {
    currentprice: {
      ...state.range.currentprice,
      selected: {
        ...state.range.currentprice.selected,
        current: getCurrentSelectedPriceRange(
          initialState,
          state,
          hasSelectedValues,
          minMaxBounds,
          refine,
          isNewPage
        )
      },
      ...minMaxBounds,
      hasSelectedValues
    }
  };
};
